/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class ActivityNotifications {
  constructor() {
    this.bindElements()
  }

  bindElements() {
    return $(".notification-feed").on(
      "click",
      ".notification.unread",
      function (e) {
        if (!$(e.target).hasClass("review-link")) {
          $(this).removeClass("unread").addClass("read")

          // TO DO: // ujs refactor
          // This should really use the link directly. However the element contains
          // sub-links that can't be wrapped. We should rethink this UI patern.
          return $(this).next(".mark-as-read-trigger").get(0).click()
        }
      }
    )
  }
}

$(document).on("turbo:load", () => new ActivityNotifications())
